import clientData from './client_data';

export default {
  clientData,
};
